module.exports = "<div class=\"box px-3 diner-tax-exempt-notice\">\n    <div class=\"py-2 ut-diner-tax-exempt-notice-text notice-text\">This order is tax-exempt, since it was paid for by a 501(c)(3) corporation.</div>\n </div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/receipt/sections/dinerTaxExemptionNotice.html
// module id = 774
// module chunks = 0